fragment BusinessUnitFields on CompanyBusinessUnit {
   __typename
      id
      _rowTimestamp
      name
      emailProductionOfficeDescription
      emailReplyName
      emailReplyTo
      isNewProjectIncluded
      chartOfAccountId
      companyChartOfAccount {
        name
      }
      _isProductionBusinessUnit
      _isUpdatable
      _isDeletable
      companyAddressesByCompanyIdAndEntityId {
        nodes {
          id
          _rowTimestamp
          addressLine1
          addressLine2
          cityName
          countryId
          country
          {
            country
          }
          stateRegionId
          stateRegion
          {stateRegion}
          postalCode
          isDeliveryAddress
          isPrimaryAddress
          telephoneNumber
          mainContact
          emailAddress
        }
      }
      companyBusinessUnitCurrencies(
        orderBy: COMPANY_CURRENCY_BY_CURRENCY_ID__NAME_ASC
      ) {
        nodes {
          id
          _rowTimestamp
          currencyId
          companyCurrency {
            isoCode
          }
          isPrimary
          isTrackingAccount
          _isUpdatable
          _isDeletable
        }
      }
}